// Section 22 and 24.5: explain(state, target) returns the factor list of the same evaluation
// the phases use, so a tooltip can never disagree with the season's result.
import { config, type Config } from '../config';
import type { Evaluation, Factor, GameState, Target } from '../core/types';
import { valueOf } from '../phases/shared/value';
import { readContext } from './context';

export function explain(state: GameState, target: Target, cfg: Config = config): Factor[] {
  return valueOf(readContext(state, cfg), target).factors;
}

/** The value and its factors, for view models that show both. */
export function evaluateTarget(state: GameState, target: Target, cfg: Config = config): Evaluation {
  return valueOf(readContext(state, cfg), target);
}
